const TopAssetTableSkeletonRow = ({ indent = 0 }: { indent?: number }) => (
  <div className="flex h-6 justify-between gap-3 animate-pulse">
    <div className="bg-ds-natural-50 w-6 rounded-md" />
    <div className="bg-ds-natural-50 grow rounded-md" />
  </div>
);

export interface TopAssetTableSkeletonProps {
  count?: number;
}

export const TopAssetTableSkeleton = ({
  count = 4,
}: TopAssetTableSkeletonProps) => {
  return (
    <div className="flex flex-col gap-9 p-4 pb-6">
      {Array.from(Array(count)).map((_, index) => (
        <TopAssetTableSkeletonRow key={index} />
      ))}
    </div>
  );
};
